import { DealershipHolidaysModule } from './../dealership-holidays/dealership-holidays.module';
import { SideNavComponent } from './sidenav/sidenav.component';
import { TopNavComponent } from './topnav/topnav.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from './../shared/shared.module';

@NgModule({
  declarations: [
    LayoutComponent,
    TopNavComponent,
    SideNavComponent
  ],
  imports: [
    CommonModule,
    LayoutRoutingModule,
    DealershipHolidaysModule,
    SharedModule,
    TranslateModule
  ],
  exports:[TranslateModule],
  providers: [],
})
export class LayoutModule { }
